import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import APP_VERSION from "../version";
import "./LoginPage.css";

function CompleteProfilePage({ user }) {
  const [form, setForm] = useState({
    username: "",
    postcode: "",
    campers: [""], // Start with one camper field
  });

  const navigate = useNavigate();

  const isValid = form.username.trim() !== "" && form.postcode.trim() !== "";

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    }
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      username: form.username,
      postcode: form.postcode,
    };

    // Map up to 5 campers into separate fields
    form.campers.forEach((name, index) => {
      payload[`camper_${index + 1}`] = name;
    });

    try {
      const res = await fetch("/profile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        navigate("/");
      } else {
        const data = await res.json();
        alert(data.error || "Failed to save profile.");
      }
    } catch (err) {
      console.error("❌ Error saving profile:", err);
      alert("Something went wrong.");
    }
  };

  const addCamper = () => {
    if (form.campers.length < 5) {
      setForm({ ...form, campers: [...form.campers, ""] });
    }
  };

  const updateCamper = (index, value) => {
    const newCampers = [...form.campers];
    newCampers[index] = value;
    setForm({ ...form, campers: newCampers });
  };

  if (!user) return null;

  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src="/camper-list.png"
          alt="Campers Logo"
          style={{ width: "200px", marginBottom: "1rem" }}
        />

        <h2>Complete Your Profile</h2>
        <p>Welcome, <strong>{user.name || user.email}</strong>!</p>
        <p>
          Let’s set up your profile and add your family vehicle details and equipment. 
          Don’t worry, you can always change this information later!
          <br />
          Only campers you add to your groups or events will be able to see this information.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            placeholder="Choose a username"
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            required
          />
          <input
            type="text"
            placeholder="Postcode"
            value={form.postcode}
            onChange={(e) => setForm({ ...form, postcode: e.target.value })}
            required
          />

          {form.campers.map((name, index) => (
            <input
              key={index}
              type="text"
              placeholder={`Camper ${index + 1}`}
              value={name}
              onChange={(e) => updateCamper(index, e.target.value)}
            />
          ))}

          {form.campers.length < 5 && (
            <button type="button" onClick={addCamper}>
              Add a camper to your profile
            </button>
          )}

          <button
            type="submit"
            disabled={!isValid}
            className={!isValid ? "disabled-button" : ""}
          >
            Save Profile
          </button>
        </form>

        <div className="version-text">
          <span>
            Version: <strong>{APP_VERSION}</strong>
          </span>
          <span style={{ marginLeft: "16px" }}>
            <a href="/contact" className="contact-link">Contact us</a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default CompleteProfilePage;
